export default __webpack_public_path__ + "static/media/econnect-white.ef3b9310.svg";